import { css, keyframes } from "@emotion/core";
import { vw } from "../cssUtil";
export const LoginShow = keyframes(`
from {
  transform: translate3d(0, 100%, 0);
}
to {
  transform: translate3d(0, 0, 0);
}
`);
export const LoginHide = keyframes `
from {
  transform: translate3d(0, 0, 0);
}
to {
  transform: translate3d(0, 100%, 0);
}
`;
export const loginStyle = css({
    backgroundColor: "#fff",
    height: "100%",
    "&.show": {
        animation: `${LoginShow} 300ms`
    },
    "&.hide": {
        animation: `${LoginHide} 300ms`
    }
});
export const logoStyle = css({
    padding: `${vw(15)} ${vw(15)} ${vw(20)}`,
    textAlign: "center",
    "h3, p": {
        margin: 0
    },
    h3: {
        fontWeight: "normal",
        fontSize: vw(24)
    },
    p: {
        fontSize: vw(14),
        color: "#999"
    },
    "@media (min-width: 769px)": {
        padding: "15px",
        h3: {
            fontSize: "24px"
        },
        p: {
            fontSize: "14px"
        }
    }
});
export const inputBoxStyle = css({
    margin: `${vw(15)} ${vw(15)}`,
    ".code": {
        position: "absolute",
        color: "#287ef9",
        fontSize: vw(16),
        right: vw(15),
        top: "50%",
        transform: "translateY(-50%)",
        "&:active": {
            color: `#287ef9`
        },
        "&.disable": {
            color: `gray`,
            fontFamily: `Arial`,
            "&:active": {
                color: `gray`
            }
        }
    },
    "@media (min-width: 769px)": {
        margin: `15px 15px`,
        ".code": {
            fontSize: "16px",
            right: "15px"
        }
    }
});
export const btnStyle = css({
    margin: `${vw(15)} ${vw(15)} 0`
});
export const privacyStyle = css({
    marginTop: vw(30),
    "&.active": {
        "svg path": {
            fill: "#287ef9"
        }
    },
    "> div": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: vw(14),
        color: "#999",
        a: {
            color: "#287ef9",
            textDecoration: "none"
        },
        svg: {
            width: vw(18),
            marginRight: vw(5),
            path: {
                fill: "#666"
            }
        }
    },
    "@media (min-width: 769px)": {
        marginTop: "30px",
        "> div": {
            fontSize: "14px",
            svg: {
                width: "18px",
                marginRight: "5px"
            }
        }
    }
});
